import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../utils/auth';
import { AppRoutes } from '../../constants/routes';
import { Box, Button, Typography } from '@mui/material';

/**
 * Route guard that only allows listeners to access the route
 * Redirects creators to their dashboard
 */
const ListenerOnlyRoute = ({ children }) => {
  const { isAuthed, isLoading, isListening, workingAs, listenAsMe } = useAuthProvider();
  const location = useLocation();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthed) {
    return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
  }

  // Someone on a dashboard (their own, or a label or publisher they run)
  // switches to listening as themselves, right here
  if (!isListening) {
    return (
      <Box sx={{ maxWidth: 520, mx: 'auto', mt: 8, px: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>This page is for listening</Typography>
        <Typography color="text.secondary">
          {workingAs ? `You're working as ${workingAs.name}.` : "You're on your dashboard."} Switch to listening as yourself to use this page.
        </Typography>
        <Button variant="contained" onClick={listenAsMe}>Switch to listening</Button>
      </Box>
    );
  }

  return children;
};

export default ListenerOnlyRoute;
